<template>
  <div class="mg-preferences">
    <swiper :options="swiperOptions">
      <swiper-slide :key="index" v-for="(overlap, index) in overlapsWithContext">
        <v-card :class="['preference-card', { 'mx-auto': pageView }]">
          <div class="profile-images">
            <v-layout class="w-100" align-center justify-space-around>
              <blw-avatar :avatars="roommates" size="64" />
            </v-layout>
          </div>
          <div :class="['overlap-status', `font-${overlap.color}`]">
            <blw-svg :name="overlap.icon" />
            <p class="lead">{{ overlap.lead }}</p>
          </div>
          <h3 class="header-sm font-large header">{{ overlap.title }}</h3>
          <p class="details">{{ overlap.subtitle }}</p>
        </v-card>
      </swiper-slide>
      <template v-if="pageView">
        <div
          v-ripple
          slot="button-prev"
          class="swiper-button swiper-button-round swiper-button-prev"
        >
          <v-icon color="charcoal">chevron_left</v-icon>
        </div>
        <div
          v-ripple
          slot="button-next"
          class="swiper-button swiper-button-round swiper-button-next"
        >
          <v-icon color="charcoal">chevron_right</v-icon>
        </div>
      </template>
      <template v-else>
        <div slot="button-prev" class="swiper-button swiper-button-bottom swiper-button-prev">
          <v-btn v-ripple flat icon>
            <v-icon color="charcoal" size="30">chevron_left</v-icon>
          </v-btn>
        </div>
        <div slot="button-next" class="swiper-button swiper-button-bottom swiper-button-next">
          <v-btn v-ripple flat icon>
            <v-icon color="charcoal" size="30">chevron_right</v-icon>
          </v-btn>
        </div>
      </template>
    </swiper>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'MeetGreetOverlap',
  props: {
    overlaps: {
      type: Array,
    },
    roommates: {
      type: Array,
    },
    pageView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 'auto',
        updateOnWindowResize: true,
        centeredSlides: true,
        simulateTouch: false,
        breakpoints: {
          320: {
            slidesPerView: 1.085,
          },
          375: {
            slidesPerView: 1.225,
          },
          450: {
            slidesPerView: 1.3,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init: this.swiperInitialized,
          slideChange: this.onSlideChange,
        },
      },
      statusIcons: {
        home_run: 'overlap_shared',
        in_between: 'overlap_between',
        strike_out: 'overlap_different',
      },
      statusColors: {
        home_run: 'green',
        in_between: 'yellow',
        strike_out: 'red',
      },
      statusLead: {
        home_run: 'shared',
        in_between: 'in between',
        strike_out: 'different',
      },
    }
  },
  computed: {
    ...mapGetters('user', ['userProfileImage']),
    overlapsWithContext() {
      return this.overlaps.map((overlap) => {
        // Inject flags and context into each card...
        overlap.icon = this.statusIcons[overlap.status]
        overlap.color = this.statusColors[overlap.status]
        overlap.lead = this.statusLead[overlap.status]
        return overlap
      })
    },
  },
  methods: {
    swiperInitialized() {
      this.$trackEvent({
        action: 'Preference Overlaps Loaded',
        properties: {
          location: 'Meet & Greet - Preferences',
          category: 'Meet & Greet',
          type: 'Event',
        },
      })
    },
    onSlideChange() {
      this.$trackEvent({
        action: 'Preference Overlap Changed',
        properties: {
          location: 'Meet & Greet - Preferences',
          category: 'Meet & Greet',
          type: 'Event',
        },
      })
    },
  },
}
</script>

<style lang="scss">
.mg-preferences {
  width: auto;
  min-height: 392px;

  @include mobile {
    width: 100vw;
    box-shadow: none !important;
  }

  .profile-images {
    margin-bottom: 2rem;
  }

  .preference-card {
    user-select: none;
    text-align: center;
    padding: 2.5rem 2.5rem;
    padding-bottom: 1.5rem;
    max-width: 284px;
    margin-bottom: 1rem;
    min-height: 450px;
    height: 100%;

    @include boxShadow();

    .overlap-status {
      margin-top: 1.25rem;
    }

    .header {
      margin: 0.75rem 0;
    }

    .details {
      font-size: 13px;
      color: $text-lighter;
    }

    .actions {
      display: flex;
    }
  }
}
</style>
